export const MIN_CYCLES_SINCE_LAST_CYCLES_WARNING = 150000;
